module.exports = __webpack_public_path__ + "static/img/plan2.d27e8fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plan2.png
// module id = roxS
// module chunks = 0